import { registerPlugin } from '@capacitor/core';
const UpdateManager = registerPlugin('UpdateManager', {
    web: () => import('./web').then((m) => new m.UpdateManagerWeb())
});
export * from './definitions';
export { UpdateManager };
//# sourceMappingURL=index.js.map